import type { FC, PropsWithChildren } from "react";
import type { UserType } from "@/types/graphql/admin";
import { AuthContext } from "./AuthContext";

export interface AuthProviderProps extends PropsWithChildren {
  user: UserType;
}

export const AuthProvider: FC<AuthProviderProps> = ({ user, children }) => {
  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};
